/* eslint-disable */
import React, { useState, useContext, useEffect, useMemo } from "react";

//import translation function for language translation
import { useTranslation } from "react-i18next";

// material react table
import { MaterialReactTable } from "material-react-table";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

/* importing dummy data */
// import reserveHistory from "../../../data/ReserveHistoryData.json";

//import context
import { GlobalProvider } from "context/GlobalContext";

const ReserveHistoryPopup = () => {
  const { reserveIdNumber, setReserveIdNumber, screenHeight } =
    useContext(GlobalProvider);

  const [reserveHistory, setReserveHistory] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation

  /* custom date html */
  const customDateHtml = ({ dataItem }) => {
    return (
      <div className="date">
        <p
          className={`mb-1 ${
            dataItem.status == "1" ? "text-success" : "text-danger"
          } `}
        >
          {dataItem.updatedAt && dataItem.updatedAt.split("T")[0]}<br/>
          {dataItem.updatedreserveby
            ? dataItem.updatedreserveby
            : dataItem.ambreservationid && dataItem.status !== "1"
            ? "Siresa"
            : ""}
        </p>
      </div>
    );
  };

  /* custom hours html */
  const customHoursHtml = ({ dataItem }) => {
    // If server-processed, a newer visit (change) is injected as `newVisit` on the item
    const newVisit = dataItem.newVisit || null;

    return (
      <div className="hours">
        <p>
          {newVisit ? (
            <>
              <span className="text-success">
                {newVisit.startdate}
                <br />
                {newVisit.starttime} - {newVisit.endtime}
              </span>
              <br />
            </>
          ) : null}

          <span className={newVisit ? "text-danger" : ""}>
            {dataItem.startdate}
            <br />
            {dataItem.starttime} - {dataItem.endtime}
          </span>
        </p>
      </div>
    );
  };

  //function for reset history
  const closeHistoryHandler = () => {
    setReserveIdNumber(null);
    setResponseReceived(false);
  };

  //function for get event history
  const getEventHistory = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_EVENT_HISTORY +
        `?token=${token}&reserveid=${reserveIdNumber}`;

      console.log("current reserveId", reserveIdNumber);

      const response = await getData(requestUrl);

      console.log("Response in history=======>", response);

      if (response.data && Array.isArray(response.data)) {
        // sort newest-first using updatedAt/createdAt/_id fallback
        const getTime = (it) => {
          if (!it) return 0;
          const dateStr = it.updatedAt || it.createdAt;
          if (dateStr) return new Date(dateStr).getTime();
          if (it._id && typeof it._id === "string" && it._id.length >= 8) {
            return parseInt(it._id.substring(0, 8), 16) * 1000;
          }
          return 0;
        };

        const sorted = [...response.data].sort((a, b) => getTime(b) - getTime(a));

        // inject `newVisit` into each item when the immediately newer record differs
        const enriched = sorted.map((item, idx) => {
          const newer = idx > 0 ? sorted[idx - 1] : null; // more recent
          if (
            newer &&
            (newer.startdate !== item.startdate ||
              newer.starttime !== item.starttime ||
              newer.endtime !== item.endtime)
          ) {
            return {
              ...item,
              newVisit: {
                startdate: newer.startdate,
                starttime: newer.starttime,
                endtime: newer.endtime,
              },
            };
          }
          return item;
        });

        setReserveHistory(enriched);
        setResponseReceived(true);
      } else if (response.data) {
        setReserveHistory(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const tableColumns = useMemo(() => [
    {
      id: "updatedAt",
      accessorKey: "updatedAt",
      header: t("Date of Modification"),
      Cell: ({ row }) => customDateHtml({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "startdate",
      accessorKey: "startdate",
      header: t("Visit Date / Time"),
      Cell: ({ row }) => customHoursHtml({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "location",
      accessorKey: "location",
      header: t("Location"),
      size: 200,
    },
    {
      id: "educator1",
      accessorKey: "educator1",
      header: t("Educator"),
      size: 200,
    },
    {
      id: "tagstring",
      accessorKey: "tagstring",
      header: t("Tags"),
      size: 200,
    },
  ], []);

  useEffect(() => {
    if (reserveIdNumber) {
      getEventHistory();
    }
  }, [reserveIdNumber]);

  

  return (
    <div
      className="offcanvas offcanvas-end border-0"
      tabIndex="-1"
      id="historyReservePopup"
      aria-labelledby="historyReservePopupLabel"
    >
      <div className="offcanvas-header align-items-start p-4">
        <h3 className="text-secondary mb-0" id="historyReservePopupLabel">
          {t("History of Reserve")}
        </h3>
        <button
          type="button"
          className="btn-close p-2 bg-white shadow-none shadow-sm m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closeHistoryHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4 pt-0">
        <div className="table-responsive">
          <MaterialReactTable
            columns={tableColumns}
            data={reserveHistory}
            enableSorting
            enableFilters
            enableGlobalFilter={false}
            enableColumnOrdering
            enableStickyHeader
            muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
            muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
            muiTableBodyProps={{ sx: { overflow: "visible" } }}
            initialState={{
              pagination: { pageSize: 100, pageIndex: 0 },
              showColumnFilters: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ReserveHistoryPopup;
